var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.subCategories),expression:"subCategories"}],staticClass:"submenu-container",attrs:{"id":"sub-categories"}},[_c('div',{staticClass:"submenu-content-container"},[_c('sidebar-component',{attrs:{"url":_vm.url,"categories":_vm.subCategories}})],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b600f96","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resources/assets/js/UI/components/child-sidebar.vue
// module id = du6a
// module chunks = 0